import { render } from "./TaxiEnLigne.vue?vue&type=template&id=d5b457f4"
import script from "./TaxiEnLigne.vue?vue&type=script&lang=js"
export * from "./TaxiEnLigne.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__